export default {"src":"/_next/static/media/noctovo.fb973dd5.svg","height":18,"width":36,"blurWidth":0,"blurHeight":0};